import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { HeroFrame } from '../../../types/content';
import { formatTimecode, pad2 } from '../../../utils/format';
interface HeroHudProps {
  frame: HeroFrame;
  index: number;
  total: number;
}
export function HeroHud({
  frame,
  index,
  total
}: HeroHudProps) {
  const reduce = useReducedMotion();
  const [elapsed, setElapsed] = useState(0);
  const [coords, setCoords] = useState({
    x: 1240.5,
    y: 388.2,
    z: -42.0
  });
  useEffect(() => {
    if (reduce) return;
    const start = performance.now();
    const id = window.setInterval(() => {
      setElapsed(performance.now() - start);
      setCoords(c => ({
        x: c.x + (Math.random() - 0.5) * 6,
        y: c.y + (Math.random() - 0.5) * 4,
        z: Math.max(-120, Math.min(0, c.z + (Math.random() - 0.5) * 2))
      }));
    }, 120);
    return () => window.clearInterval(id);
  }, [reduce]);
  return <div className="absolute right-6 top-[44%] w-[272px] border border-white/10 bg-night/70 p-4 font-mono text-[11px] text-white/60 backdrop-blur-sm xl:right-10" data-id="element-172" data-mp="p6wiq2t9nyuv">
      <div className="flex items-center justify-between" data-id="element-173" data-mp="t6wwdl8jk60v">
        <span className="flex items-center gap-2 text-white" data-id="element-174" data-mp="y72u9j5emore">
          <span className="h-2 w-2 animate-blink bg-ember" data-id="element-175" data-mp="y5rojdsef6xn" />
          REC
        </span>
        <span className="tabular-nums" data-id="element-176" data-mp="134l3lanc35zx">{formatTimecode(elapsed)}</span>
      </div>

      <div className="mt-4 h-[46px] border-t border-white/10 pt-3" data-id="element-177" data-mp="5ki2wioxicnu">
        <AnimatePresence mode="wait" initial={false} data-id="element-178" data-mp="ah8ht2ozz27o">
          <motion.div key={frame.id} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-179" data-mp="afnlb7j4h976">
            <p className="font-sans text-[15px] font-medium text-white" data-id="element-180" data-mp="3ix0j9gauj1rl">{frame.process}</p>
            <p className="mt-0.5 truncate" data-id="element-181" data-mp="3nvv0idt60i9l">{frame.detail}</p>
          </motion.div>
        </AnimatePresence>
      </div>

      <dl className="mt-3 grid grid-cols-3 gap-2 border-t border-white/10 pt-3 tabular-nums" data-id="element-182" data-mp="3funn7ghhdsa0">
        {(['x', 'y', 'z'] as const).map(axis => <div key={axis} data-id="element-183" data-mp="3plqq8ntz0hbx">
            <dt className="text-ember" data-id="element-184" data-mp="3pkyrj452u3hf">{axis.toUpperCase()}</dt>
            <dd className="text-white/85" data-id="element-185" data-mp="3kmx82i3qo25f">{coords[axis].toFixed(1)}</dd>
          </div>)}
      </dl>

      <p className="mt-3 border-t border-white/10 pt-3" data-id="element-186" data-mp="2wx2w02r8uhm8">
        Séquence {pad2(index + 1)} / {pad2(total)}
      </p>
    </div>;
}